import React from 'react';
import { experience, education } from '../../portfolio';
import './Experience.css';
import defaultExperienceImage from './experience.jpg';
import ipserLabImage from './ipserlab.jpg';
import northeastern from './northeastern.jpg';
import puneUniversityImage from './puneuniversity.jpg'; // Import image for Savitribai Phule Pune University
import walmartImage from './walmart2.png'; // Import image for Walmart

const Experience = () => (
  <section id='experience-education'>
    <div className='experience-education-container'>
      <div className='experience-section'>
        <h2 className='section-title'>Experience 💼</h2>
        <div className='experience-container'>
          {experience.map((exp, index) => (
            <div key={index} className='experience-item'>
              <div className='experience-image'>
                <img
                  src={
                    exp.company === 'IpserLab'
                      ? ipserLabImage
                      : exp.company === 'Walmart'
                      ? walmartImage
                      : defaultExperienceImage
                  }
                  alt={exp.company}
                />
              </div>
              <div className='experience-details'>
                <h3 className='experience-company'>{exp.company}</h3>
                <p className='experience-role'>{exp.role}</p>
                <p className='experience-duration'>{exp.duration}</p>
                <p className='experience-description'>{exp.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className='education-section'>
        <h2 className='section-title'>Education 👨‍🎓</h2>
        <div className='education-container'>
          {education.map((edu, index) => (
            <div key={index} className='education-item'>
              <div className='education-image'>
                <img
                  src={
                    edu.institution === 'Savitribai Phule Pune University'
                      ? puneUniversityImage
                      : northeastern
                  }
                  alt={edu.institution}
                />
              </div>
              <div className='education-details'>
                <h3 className='education-institution'>{edu.institution}</h3>
                <p className='education-degree'>{edu.degree}</p>
                <p className='education-duration'>{edu.duration}</p>
                <p className='education-description'>{edu.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

export default Experience;
